import React, { useState } from 'react';
import { Wrapper } from "../../Views/CommonStyles";
import { Title } from "./styles";
import Row from "../../Shared/Kit/Row";
import Header from "../../Shared/Header";
import Section from "../../Views/Announcements/Section";

const Announcements = () => {
  const listItem = [
    // {
    //   id: 0,
    //   title: "شرایط خرید واحد های مسکونی باقیمانده برج اسپاد ویژه همکاران",
    //   description: "شرایط خرید واحد های مسکونی باقیمانده برج اسپاد ویژه همکاران طبق مصوبه هیئت مدیره بانک به شرح پیوست می باشد",
    //   entryDate: "1404-04-21",
    //   url: "../Notifications",
    //   expanded: true,
    // },
    {
      id: 1,
      title: "نظر سنجی شماره یک",
      description: "در خصوص پروژه بزرگ مسکونی تجاری منطقه 22 (نظر سنجی شماره یک) در صورت مشارکت کافی همکاران اقدام به خرید زمین . . .",
      entryDate: "1401-11-05",
      url: "/Assets/Files/7179.pdf",
      expanded: false,
    },
    {
      id: 2,
      title: "تمدید مهلت شرکت در نظر سنجی",
      description: "پیرو نامه شماره 01/219/7179 مورخ 1401/11/05 مبنی بر امکان شرکت در نظرسنجی شماره 1 در خصوص . . .",
      entryDate: "1401-11-11",
      url: "/Assets/Files/7187.pdf",
      expanded: false,
    },
    {
      id: 3,
      title: "جلسه هیات امناء در خصوص خرید زمین",
      description: "جلسه هیات امناء موسسه رفاه و تامین آتیه کارکنان بانک سپه مورخ 1401/11/23 در محل ساختمان نگین بانک سپه برگزار گردید و در خصوص . . .",
      entryDate: "1401-11-23",
      url: "/Assets/Files/7198.pdf",
      expanded: false,
    },
    {
      id: 4,
      title: "نتیجه نظرسنجی شماره 1",
      description: "پیرو اطلاعیه های شماره 01/219/7187 مورخ 1401/11/11 و شماره 01/448/7198 مورخ 1401/11/17 در رابطه با نظر سنجی شماره یک . . .",
      entryDate: "1401-11-24",
      url: "/Assets/Files/7219.pdf",
      expanded: false,
    },
    {
      id: 5,
      title: "هماهنگی لازم برای ابلاغ نتیجه نظر سنجی",
      description: "پیرو نامه شماره 01/219/7219 مورخ 1401/11/24 در خصوص مشارکت همکاران شاغل، بازنشسته، از کار افتاده و . . .",
      entryDate: "1401-11-26",
      url: "/Assets/Files/7223.pdf",
      expanded: false,
    },
    {
      id: 6,
      title: "مشخصات زمین منطقه 22",
      description: "پیرو نامه 01/241/7223 مورخ 1401/11/26 در خصوص پروژه منطقه 22 تهران اطلاعات تکمیلی در اطلاعیه نظر سنجی شماره یک به شرح زیر . . .",
      entryDate: "1401-11-27",
      url: "/Assets/Files/7224.pdf",
      expanded: false,
    },
    {
      id: 7,
      title: "تمدید مدت واریز وجه برای مشارکت",
      description: "حسب اعلام حوزه پشتیبانی بانک سپه تاریخ شرکت در مزایده خرید زمین مورد نظر تمدید شده ولذا کلیه همکاران می توانند تا تاریخ . . .",
      entryDate: "1401-12-04",
      url: "/Assets/Files/7242.pdf",
      expanded: false,
    },
    {
      id: 8,
      title: "نامه تمدید مدت واریز وجه به اداره کل روابط عمومی",
      description: "پیرو اطلاعیه شماره 01/247/7242 مورخ 1401/12/04 به استحضار کلیه همکاران و مشارکت کنندگان محترم میرساند . . .",
      entryDate: "1401-12-23",
      url: "/Assets/Files/7319.pdf",
      expanded: false,
    },
    {
      id: 9,
      title: "فرم انصراف از سرمایه گذاری پروژه منطقه 22 (فرم شماره 2)",
      description: "افرادی که تمایل به کاهش یا انصراف از سرمایه گذاری خود دارند فرم زیر را دریافت و پس از تکمیل. . .",
      entryDate: "1402-02-01",
      url: "/Assets/Files/InvestmentCancellation.pdf",
      expanded: false,
    },
    {
      id: 10,
      title: "معرفی سایت شرکت ساختمانی ایمن ساخت برزین",
      description: "افرادی که در پروژه منطقه 22 تهران پذیره نویسی نموده اند به سایت شرکت ساختمانی ایمن ساخت برزین به آدرس . . .",
      entryDate: "1402-08-24",
      url: "/Assets/Files/291.pdf",
      expanded: false,
    },
    {
      id: 11,
      title: "افراد جا مانده از ثبت نام در سایت",
      description: "درخصوص ثبت اطلاعات سرمایه گذاران پروژه منطقه 22 در سایت شرکت ساختمانی ایمن ساخت برزین، نیمی از سرمایه گذاران اطلاعات خود را . . .",
      entryDate: "1402-10-09",
      url: "/Assets/Files/381.pdf",
      expanded: false,
    },
    {
      id: 12,
      title: "اطلاعیه دریافت قرارداد مشارکت سرمایه گذاران",
      description: "به استحضار همکاران محترم میرساند از روز شنیه مورخ 1403/02/08 سرمایه گذاران محترم می توانند با مراجعه به تارنمای شرکت . . .",
      entryDate: "1403-02-04",
      url: "/Assets/Files/743.pdf",
      expanded: false,
    },
    {
      id: 13,
      title: "واریز سود اشخاص انصرافی پروژه",
      description: "نظر به اینکه تعدادی از سرمایه گذاران پروژه منطقه 22 تهران از مشارکت در پروژه مذکور انصراف . . .",
      entryDate: "1403-05-20",
      url: "/Assets/Files/1077.pdf",
      expanded: false,
    },
    {
      id: 14,
      title: "برای دریافت قرارداد مشارکت سرمایه گذاران",
      description: "به استحضار مشارکت کنندگان محترم در پروژه مزبور میرساند کلیه قرارداد مشارکت سرمایه گذاران . . .",
      entryDate: "1404-07-28",
      url: "/Assets/Files/2053.pdf",
      expanded: false,
    },
    {
      id: 15,
      title: "آخرین وضعیت پروژه",
      description: "پیرو اطلاعیه شماره ۰۴/۱۴۰۷/۲۰۵۳ مورخ ۱۴۰۴/۰۷/۲۸ به منظور آگاهی افراد مشارکت کننده در پروژه منطقه ۲۲ تهران در رابطه با پیشرفت . . .",
      entryDate: "1405-05-10",
      url: "/Assets/Files/2431.pdf",
      expanded: true,
    },
  ];

  return (
    <Wrapper>
      <Header headerColor={"white"} />
      <Title>اطلاعیه ها</Title>
      <Row className="content">
        {[...listItem].reverse()?.map((each, index) => {
          return (
            <>
              <Row className="section">
                <Section
                  name={"announcement"}
                  item={each}
                  maxHeight={"500px"}
                />
              </Row>
            </>
          )
        }
        )}
      </Row>
    </Wrapper>
  );
};

export default Announcements;